<div class="section" style="overflow: hidden !important">
  <div class="row">
    <div class="col-sm">
      <div class="close-header">
        <div (click)="oncancelClick()" style="cursor: pointer">
          <img
            src="assets/images/icons/close-icon.png"
            style="margin: 10px 10px; height: 11px; width: 11px"
          />
        </div>
      </div>
    </div>
  </div>
  <div style="padding: 0 20px 20px 20px">
    <div style="margin-bottom: 10px; font-size: 12px; color: #49526e">
      {{ popupData.title }}
    </div>

    <!-- Projects: Only show title as clickable link -->
    <div class="popup-data" *ngIf="popupData.seeMoreType === 'projects'">
      <ul>
        <li *ngFor="let item of popupData.items">
          <ng-container *ngIf="item.url; else plainText">
            <a
              [href]="item.url"
              target="_blank"
              rel="noopener"
              class="highlight-link"
              [innerHTML]="item.title | highlight : searchText"
            ></a>
          </ng-container>
          <ng-template #plainText>
            <span [innerHTML]="item.title | highlight : searchText"></span>
          </ng-template>
        </li>
      </ul>
    </div>

    <!-- Products: name as link, title after dash -->
    <div class="popup-data" *ngIf="popupData.seeMoreType === 'products'">
      <ul>
        <li *ngFor="let item of popupData.items">
          <ng-container *ngIf="item.url; else plainText">
            <a
              [href]="item.url"
              target="_blank"
              rel="noopener"
              class="highlight-link"
              [innerHTML]="item.name | highlight : searchText"
            ></a>
            <span>
              - <span [innerHTML]="item.title | highlight : searchText"></span>
            </span>
          </ng-container>
          <ng-template #plainText>
            <span
              [innerHTML]="item.display || item | highlight : searchText"
            ></span>
          </ng-template>
        </li>
      </ul>
    </div>

    <!-- Claims -->
    <div class="popup-data" *ngIf="popupData.seeMoreType === 'claims'">
      <ul>
        <li *ngFor="let item of popupData.items">
          <ng-container *ngIf="item.url; else plainText">
            <a
              [href]="item.url"
              target="_blank"
              rel="noopener"
              class="highlight-link"
              [innerHTML]="item.name | highlight : searchText"
            ></a>
            <span>
              -
              <span
                [innerHTML]="item.statement | highlight : searchText"
              ></span>
            </span>
          </ng-container>
          <ng-template #plainText>
            <span
              [innerHTML]="item.display || item | highlight : searchText"
            ></span>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
</div>
